import apiClient from '../../shared/auth/services'

/**
 * モバイルパスワードリセット送信サービス
 * メールアドレス存在確認とパスワードリセットメール送信機能を提供
 */
export const mobileSendResetPasswordService = {
  /**
   * メールアドレス存在確認
   * 指定されたメールアドレスがシステムに登録されているか確認
   * @param {string} mailAddress - 確認対象のメールアドレス
   * @returns {Promise<Object>} 存在確認結果
   */
  async getPixtagUserCount(mailAddress) {
    const response = await apiClient.post('/getPixtagUserCount', {
      mailAddress: mailAddress
    })
    return response.data
  },

  /**
   * パスワードリセットメール送信
   * 指定されたメールアドレスにパスワードリセット用のメールを送信
   * @param {string} mailAddress - 送信先メールアドレス
   * @returns {Promise<Object>} 送信結果
   */
  async sendResetPassword(mailAddress) {
    const response = await apiClient.post('/sendResetPassword', {
      mailAddress: mailAddress
    })
    return response.data
  },
}

export default mobileSendResetPasswordService
